import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { minimalAgencyType } from './props/agency-type';
import * as styles from './sidebox-agency-logos.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var relevantProps = ['name', 'logo', 'profileUrl', 'logoBackground'];
var sameAgency = (agency1, agency2) => agency1 != null && agency2 != null && (agency1 === agency2 || relevantProps.every(prop => agency1[prop] === agency2[prop]));
var AgencyLogos = _ref => {
  var agencies = _ref.agencies,
    active = _ref.active;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  if (!agencies.some(agency => agency.logo)) {
    return null;
  }
  var distinctAgencies = agencies.reduce((result, agency, index) => {
    var _ref2 = result.length > 0 ? [result.slice(0, result.length - 1), result[result.length - 1]] : [[]],
      _ref3 = _slicedToArray(_ref2, 2),
      head = _ref3[0],
      tail = _ref3[1];
    return sameAgency(tail, agency) ? [...head, _objectSpread(_objectSpread({}, tail), {}, {
      active: tail && tail.active || index === active
    })] : [...head, ...(tail ? [tail] : []), _objectSpread(_objectSpread({}, agency), {}, {
      active: index === active
    })];
  }, []);
  return ___EmotionJSX("a", {
    css: styles.logoContainer,
    href: agencies[active].profileUrl,
    onClick: () => sendEvent('agency-sidebox-profile-click', {
      agencyId: agencies[active].id,
      agencyName: agencies[active].name
    })
  }, distinctAgencies.map(agency => ___EmotionJSX("span", {
    key: agency.name,
    "data-testid": "agency-logo",
    css: /*#__PURE__*/_css([styles.logo(agency.logoBackground), agency.active && styles.active])
  }, agency.logo && ___EmotionJSX("img", {
    css: styles.logoImage,
    alt: agency.name,
    src: agency.logo
  }))));
};
AgencyLogos.propTypes = {
  agencies: PropTypes.arrayOf(PropTypes.shape(minimalAgencyType)),
  active: PropTypes.number
};
AgencyLogos.defaultProps = {
  agencies: [],
  active: 0
};
export default AgencyLogos;